import Swiper from 'swiper'
import { selectAll } from 'helpers/dom'
import { getOptionsByType, getSelector, defaultSelector } from './swiper-utils'
import { Navigation, Pagination, Scrollbar, Autoplay, A11y } from 'swiper/modules'

class SwiperInstanceNative {
  constructor(element, options, config, type) {
    this.element = element
    this.selector = getSelector(this.element, defaultSelector.native.CAROUSEL_SWIPER_SELECTOR)
    this.options = getOptionsByType(this.element, options, config, type)
    this.swiper = this.element
    this.init()
  }

  init() {
    const checkSelectorItems = selectAll(`.${this.selector}`)

    if (!checkSelectorItems.length) {
      return
    }

    if (checkSelectorItems.length > 1) {
      // eslint-disable-next-line no-console
      console.error('Swiper: Multiple instances of the same selector are not supported', checkSelectorItems)

      return
    }

    this.swiper = new Swiper(`.${this.selector}`, {
      modules: [Navigation, Pagination, Scrollbar, Autoplay, A11y],
      ...this.options
    })
  }
}

export default SwiperInstanceNative
